import { Colors } from '@/common/colors/colors';
import styled from 'styled-components';

export const Container = styled.div`
	margin-top: 50px;
	max-width: 400px;
	display: flex;
	flex-direction: column;
	margin-inline: auto;
`;

export const Header = styled.h2`
	color: ${Colors.darkBlue};
	align-self: center;
`;

export const Form = styled.form`
	margin-top: 50px;
	max-width: 400px;
	display: flex;
	flex-direction: column;
	margin-inline: auto;
	gap: 20px;
`;

export const ButtonContainer = styled.div`
	align-self: flex-end;
`;
